const CASES = [
  {
    field: "自動車 / 薄膜デバイス",
    title: "自動車向け薄膜センサの研究・実験支援",
    body: "自動車向け薄膜センサの試作・研究段階において、成膜条件、膜厚、環境条件などの影響要因を整理し、再現性のある評価方法と実験計画の構築を支援しました。",
    tags: ["薄膜", "研究支援", "評価設計"],
    icon: "ri-cpu-line",
  },
  {
    field: "光学 / レンズ",
    title: "光学レンズの熱衝撃による変形原因の分析",
    body: "特定条件下で発生するレンズ変形について、温度分布、応力、材料特性など複数の観点から仮説を設定し、変形メカニズムを整理しました。",
    tags: ["熱衝撃", "光学", "変形解析"],
    icon: "ri-focus-3-line",
  },
  {
    field: "UV硬化 / コーティング",
    title: "UV硬化工程における非対称硬化の原因分析と対策検討",
    body: "UV硬化時に発生する非対称な硬化現象について、光量分布、被塗物形状、材料特性、工程条件を切り分け、対策の方向性を整理しました。",
    tags: ["UV硬化", "工程設計", "対策検討"],
    icon: "ri-flashlight-line",
  },
];

export default function Cases() {
  return (
    <section id="cases" className="w-full py-24 md:py-32 bg-background-200/60">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Case Studies</span>
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug mb-6">
            <a href="#cases" className="cursor-pointer">実績・事例</a>
          </h4>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            機密上、詳細な社名・条件・数値は伏せていますが、
            代表的な研究・改善事例をご紹介します。
            具体的な工程・条件については、必要に応じてNDA締結後にご相談ください。
          </p>
        </div>

        <div className="space-y-5 md:space-y-6">
          {CASES.map((c, i) => (
            <article
              key={c.title}
              className="bg-background-50 border border-background-200 rounded-lg p-7 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 hover:border-primary-300 transition-colors"
            >
              <div className="md:col-span-3 flex md:flex-col items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${c.icon} text-lg`}></i>
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.25em] text-secondary-500 mb-1">
                    CASE {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="text-xs text-foreground-700">{c.field}</div>
                </div>
              </div>
              <div className="md:col-span-9">
                <h5 className="font-heading text-xl md:text-2xl text-foreground-900 mb-4 leading-snug">
                  {c.title}
                </h5>
                <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed mb-5">
                  {c.body}
                </p>
                <div className="flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="inline-flex items-center px-3 py-1 bg-secondary-100 text-secondary-900 text-[11px] rounded-full whitespace-nowrap"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}